var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.params.node.data.hasOwnProperty('compromissoEntregaAtrasado'))?_c('feather-icon',{staticClass:"ml-1",attrs:{"icon":"InfoIcon","svgClasses":"h-6 w-6 stoke-current text-danger"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }